import ViewFraudTracking from 'components/viewFraudTracking/ViewFraudTracking.component';

const ViewFraudTrackingPage = () => {
	return <ViewFraudTracking />;
};

export default ViewFraudTrackingPage;
